import React, {useEffect, useState} from "react";
import {Table} from "react-bootstrap";
import {FaEye} from "react-icons/fa";
import {ShowImportErrors} from "./ShowImportErrors";
/*import {ShowImportErrors} from "../Modal/ShowImportErrors.jsx";*/


const ErrorTable = ({invalidRecords}) => {
    const [show, setShow] = useState(false);
    const [errorsToShow, setErrorsToShow] = useState();
    useEffect(() => {
        console.log(invalidRecords)
    }, [invalidRecords]);
    return (
        <>
            <div className={'card py-4'}>
                <h2 className={'text-start px-4'}>Errori importazione File</h2>
                <hr className={'mt-1'}/>
                <div className={'px-4'}>
                    <Table className={'table-responsive noRounded'}>
                        <thead>
                        <tr className={'bg-primary text-white'}>
                            <th className={'bkg-primary text-white'}>Riga</th>
                            <th className={'bkg-primary text-white '}>Nome</th>
                            <th className={'bkg-primary text-white'}>Cognome</th>
                            <th className={'bkg-primary text-white'}>Email</th>

                            <th className={'bkg-primary text-white'}>Errori</th>
                            <th className={'bkg-primary text-white'}></th>
                        </tr>
                        </thead>
                        <tbody>
                        {invalidRecords.map((record, idx) => {
                            const totalErrors = Object.keys(record.errors).length;

                            return (
                                <tr key={idx} className={'border-bottom border-bottom-1 border-light'}>
                                    <td>  {record?.row_count}  </td>
                                    <td> {record.first_name}</td>
                                    <td>  {record?.last_name}  </td>
                                    <td>  {record?.email}  </td>

                                    <td>  {totalErrors}</td>

                                    <td><FaEye className={'cursor-pointer'} onClick={() => {
                                        setErrorsToShow(record.errors)
                                        setShow(true)
                                    }}/></td>
                                </tr>
                            );
                        })}
                        </tbody>
                    </Table>
                </div>
                <ShowImportErrors show={show} handleClose={() => {
                    setShow(false);

                }} errorsToShow={errorsToShow}/>
            </div>
        </>
    );
};

export default ErrorTable;
